import type { Palette, TypographyVariantsOptions } from '@mui/material/styles';

export const typographyValues: React.CSSProperties = {
  fontFamily: 'DM Sans, sans-serif',
  fontSize: 16,
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: 'normal',
  letterSpacing: '0.3px',
  textUnderlineOffset: '4px',
};

export const typographyOverrides = (palette: Palette): TypographyVariantsOptions => ({
  allVariants: { ...typographyValues, color: palette.text.primary },
  fontWeightBold: 700,
  fontWeightMedium: 500,
  fontWeightRegular: 400,
  h1: { fontSize: 40, fontWeight: 700 },
  h2: { fontSize: 36, fontWeight: 700 },
  h3: { fontSize: 32, fontWeight: 700 },
  h4: { fontSize: 28, fontWeight: 700 },
  h5: { fontSize: 24, fontWeight: 700 },
  h6: { fontSize: 20, fontWeight: 700 },
  subtitle1: { fontSize: 18, fontWeight: 700 },
  body1: { fontSize: 16 },
  body2: { fontSize: 14 },
  body3: { fontSize: 12 },
  body4: { fontSize: 10 },
});
